<template>
  <div>
    <div
      :id="id"
      class="grapesjs-container"
    />
    <BaseDialog
      ref="dynamicContentDialog"
      :is-iframe="false"
      :custom-content-template="dynamicContent"
      :title="dynamicContentDialogHeader"
      :force-header="true"
      :on-open="onModalOpen"
      :on-close="onModalClose"
      :show-close-icon="true"
      width="90%"
      height="90%"
    />
    <!-- :on-close-dialog="onCloseDialog" -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseDialog from '@/components/Dialog/BaseDialog'
import DynamicContent from '@/components/DynamicContent'
import { iframeParentCommunication } from '@/mixins/iframeParentCommunication'

export default {
  components: {
    BaseDialog
  },
  mixins: [iframeParentCommunication],
  props: {
    value: {
      type: Object
    },
    id: {
      type: String,
      required: false,
      default: 'grapejs-plugin'
    },
    config: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      editor: null,
      grapejsInstance: null,
      dynamicContent: DynamicContent,
      dynamicContentDialogHeader: 'Help'
    }
  },
  computed: {
    ...mapGetters({
      accountId: 'getAccountId',
      eGalleryUid: 'getEGalleryUid'
    })
  },
  watch: {
    value (newVal, oldVal) {
      if (newVal.by !== oldVal.by && newVal.by === 'server') {
        // console.log('watch:value', newVal, oldVal)
        this.init()
      }
    },
    accountId (newVal, oldVal) {
      if (newVal !== oldVal && newVal > 0) {
        // console.log('watch:accountId', newVal, oldVal)
        this.init()
      }
    },
    eGalleryUid (newVal, oldVal) {
      if (newVal !== oldVal && newVal > 0) {
        // console.log('watch:eGalleryUid', newVal, oldVal)
        this.init()
      }
    }
  },
  mounted () {
    this.$store.commit('SET_DYNAMIC_CONTENT_MODAL_REF', this.$refs.dynamicContentDialog)
    window.removeEventListener('message', this.receivePostMessage)
    window.addEventListener('message', this.receivePostMessage, false)
    if (this.accountId) {
      // console.log('mounted:accountId')
      this.init()
    }
  },
  destroyed () {
    this.$store.commit('SET_DYNAMIC_CONTENT_MODAL_REF', null)
    this.$store.commit('SET_GRAPES_JS_INSTANCE', null)
  },
  methods: {
    onModalOpen () {
      this.$store.commit('SET_DYNAMIC_CONTENT_MODAL_OPEN', true)
    },
    onModalClose () {
      this.$store.commit('SET_DYNAMIC_CONTENT_MODAL_OPEN', false)
    },
    receivePostMessage (e) {
      const { data } = e
      // console.log('TBI UI receivePostMessage: ', e)
      // console.log('TBI UI receivePostMessage: ', data)
      if (data) {
        if (data.action) {
          switch (data.action) {
            case 'save':
              if (data.args) {
                const [html = '', htmlJson = '', styleJson = ''] = data.args
                this.$emit('input', { by: 'grapesjs', html, htmlJson, styleJson })
              }
              break
            case 'openMoreOption':
              if (data.args && data.args.length) {
                const [target] = data.args
                switch (target) {
                  case 'tabnoAddOnSnippet':
                    this.$store.commit('SET_DYNAMIC_CONTENT_SELECTED_TAB', 3)
                    break
                  case 'tabnoPersonalizationTags':
                    this.$store.commit('SET_DYNAMIC_CONTENT_SELECTED_TAB', 4)
                    break
                }
                this.$refs.dynamicContentDialog.openDialog()
              }
              break
            case 'egallerySelectImg':
              if (data.args && data.args.length) {
                // console.log('TBI UI egallerySelectImg callback: ', data.args)
                // window.open(data.args[0], '_blank')
                const message = { action: 'eIn_Open_eGallery', value: data.args[0] }
                this.SendMessageToParent(message)
              }
              break
            default:
              break
          }
        } else if (data.property === 'tbi_processEGalleryCommand') {
          this.grapejsInstance.tbi_eGallerySelectedImage(data.data)
        } else if (data.egallery) {
          this.grapejsInstance.sendImage(data)
        } else if (data.moreoption) {
          this.grapejsInstance.InsertMoreOptData(data)
        } else if (data.toggleAdvancedOptions) {
          data.toggleAdvancedOptions()
        }
      }
    },
    initialEditorCallBack (instance) {
      if (typeof grapejsInstance === 'undefined') {
        this.$store.commit('SET_GRAPES_JS_INSTANCE', instance)
        this.grapejsInstance = instance
        this.initGrapeJSEditor()
      }
    },
    initGrapeJSEditor () {
      this.grapejsInstance.load([
        this.value.htmlJson,
        this.value.styleJson,
        this.value.html
      ])
    },
    editorOnSaveCallback (html) {
      const wnd = window.open('about:blank', '', 'width=800,height=500')
      wnd.document.write(html)
    },
    init () {
      if ((this.value.by !== 'server' && this.$route.params.id) || !this.accountId || !this.eGalleryUid || document.querySelector(`#${this.id}`).innerHTML.length) return
      const interval = setInterval(() => {
        if (typeof window.GrapesPlugin !== 'undefined' && window.GrapesPlugin.creategrapejs !== undefined) {
          const newConf = JSON.parse(JSON.stringify(this.config))
          newConf.customizationConfig.einsightConfig.dynamicContentApi.accountId = this.accountId
          newConf.customizationConfig.einsightConfig.dynamicContentApi.parentDomain = this.$store.getters.getEinsightUri
          newConf.customizationConfig.tuiImage.einsightTuiImageConfig.UID = this.eGalleryUid
          newConf.customizationConfig.einsightConfig.companyID = this.$store.getters.getExternalId
          newConf.customizationConfig.einsightConfig.userName = this.$store.getters.getUserEmail
          newConf.customizationConfig.einsightConfig.eInsightDomain = this.$store.getters.getEinsightUri

          window.GrapesPlugin.creategrapejs(newConf, this.initialEditorCallBack)
          clearInterval(interval)
        } else {
          console.log('timer')
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss">
.grapesjs-container iframe {
  min-height: 952px;
}
</style>
